import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import { PromotionDetails, PromotionList } from 'components/Promotion';

const PromotionsRouter = () => {
  const promotions = SiteConfigManager.getComponentPath(COMPONENT_TYPES.PROMOTIONS);

  return (
    <Switch>
      <Route component={PromotionDetails} path={`${promotions}/:id`} />
      <Route component={PromotionList} path={`${promotions}`} />
    </Switch>
  );
};

export default PromotionsRouter;
